import React, { useRef } from 'react';

import { sanitizeContent } from 'utilities/comments';

import useCommentVideoEmbed from 'hooks/useCommentVideoEmbed';

import styles from './styles.module.less';

const PostBody = props => {
  const { content } = props;

  const postRef = useRef();

  useCommentVideoEmbed(postRef);

  return (
    <div
      ref={postRef}
      className={styles.postBody}
      dangerouslySetInnerHTML={{ __html: sanitizeContent(content) }}
    />
  );
};

export default PostBody;
